<template>
  <div class="project-info header">
    <div>
      <div class="title">
        <div class="name">
          <p>{{ info.projectName }}</p>
          <p v-if="cityId !== '3309'">{{ address }}</p>
        </div>
        <div class="qrcode">
          <!-- <img src="https://cdn.ideamake.cn/de7c722f8399fecc648a1317979eb624/20220525_1746116e185a7393ce495cbe4f117ab09f3085.png"> -->

          <el-image
            style="width: 100px; height: 100px"
            :src="wxCode3"
            fit="cover">
            <div slot="error" class="image-slot wx-code-loading">
              <i class="el-icon-loading"></i>
              <div class="text">加载中</div>
            </div>
          </el-image>

        </div>
      </div>
      <div class="price">
        <span v-if="info.displayPriceType === 2">总价</span>
        <span v-else>均价</span>
        <span>{{ projectPrice }}</span>
        <span>{{ projectPriceUnit }}</span>
      </div>
    </div>
    <div class="info-tags">
      <div class="info-item">
        <span>占地面积</span>
        <span>{{ floorArea }}</span>
      </div>
      <div class="info-item">
        <span>开盘时间</span>
        <span>{{ info.startSaleTime || '待定' }}</span>
      </div>
      <div class="info-item">
        <span>主力户型</span>
        <span>{{ info.mainHouse }}</span>
      </div>
      <div v-if="cityId !== '3309'" class="info-item">
        <span>楼盘地址</span>
        <span>{{ info.detailAddress || '--' }}</span>
      </div>
      <div class="tags-wrap">
        <span class="tags" v-for="(item, j) in tags" :key="j">{{ item }}</span>
      </div>

    </div>
    <div class="telephone" v-show="officialPhone">
      <div class="title">咨询电话</div>
      <div class="phone">
        <i class="el-icon-phone"></i>
        <span class="phone-number">{{ officialPhone }}</span>
        <!-- <span  class="el-icon-title">预约看房</span> -->
      </div>
      <div class="wx-code">

        <div class="right-item wx" @mouseover="mouseOver" @mouseleave="wxCodeShow = false">
          <img class="right-item-thumbnail" alt="icon" referrerpolicy="no-referrer"
            src="https://xfjoss.coli688.com/pc-images/details-code1.png" />
          <div class="wx-word">推荐客户</div>
          <!-- <div class="wx-popu">
            <img class="wx-img" src="https://cdn.ideamake.cn/de7c722f8399fecc648a1317979eb624/20220525_1657160a1961657b354b839a19c5c8363396a3.png">
          </div> -->
          <transition name="el-zoom-in-top">
            <div class="wx-popu" v-show="wxCodeShow">
              <img class="wx-img" alt="二维码" src="https://cdn.ideamake.cn/de7c722f8399fecc648a1317979eb624/20220525_1657160a1961657b354b839a19c5c8363396a3.png">
              <div class="wx-code">
                <el-image style="width: 150px; height: 150px" :src="wxCode" fit="cover">
                  <div style="margin-top: 25px;" slot="error" class="image-slot wx-code-loading">
                    <i class="el-icon-loading"></i>
                    <div class="text">加载中</div>
                  </div>
                </el-image>
              </div>
            </div>
          </transition>
        </div>

        <div class="right-item wx right-item2" @mouseover="mouseOver2" @mouseleave="wxCodeShow2 = false">
          <img class="right-item-thumbnail" alt="icon" referrerpolicy="no-referrer"
            src="https://xfjoss.coli688.com/pc-images/details-code2.png" />
          <div class="wx-word">预约看房</div>
          <transition name="el-zoom-in-top">
            <div class="wx-popu" v-show="wxCodeShow2">
              <img class="wx-img" alt="二维码" src="https://cdn.ideamake.cn/de7c722f8399fecc648a1317979eb624/20220525_1657160a1961657b354b839a19c5c8363396a3.png">
              <div class="wx-code">
                <el-image style="width: 150px; height: 150px" :src="wxCode2" fit="cover">
                  <div style="margin-top: 25px;" slot="error" class="image-slot wx-code-loading">
                    <i class="el-icon-loading"></i>
                    <div class="text">加载中</div>
                  </div>
                </el-image>
              </div>
            </div>
          </transition>
        </div>

      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
export default {
  name: 'project-info',
  props: {
    info: {
      type: Object,
      default() {
        return {}
      }
    },
    projectCode: {
      type: String,
      default: ''
    },
    tags: {
      type: Array,
      default() {
        return []
      }
    },
  },
  data() {
    return {
      projectDetail: {},
      introduce: [
        { label: '占地面积', value: '约3.23万㎡' },
        { label: '占地面积', value: '约3.23万㎡' },
        { label: '占地面积', value: '约3.23万㎡' }
      ],
      offsetTop: 0,
      offsetHeight: 0,
      wxCode: null,
      wxCodeShow: false,
      timer: null,
      wxCode2: null,
      wxCodeShow2: false,
      timer2: null,
      wxCode3: null,
    }
  },
  computed: {
    ...mapGetters([
      'homePage',
      'cityId'
    ]),
    officialPhone () {
      return this.info.officialPhone
    },
    address() {
      const area = this.info.area
      return `${area && area.city && area.city.name}·${area && area.district && area.district.name}`
    },
    floorArea() {
      const { floorArea, floorAreaUnit } = this.info
      return `${floorArea || '--'}${floorAreaUnit || 'm²'}`
    },
    projectPrice() {
      let {
        averagePrice, averagePriceUnit, displayPriceType,
        lowestTotalPrice, topTotalPrice, totalPriceUnit,
      } = this.info
      averagePrice = averagePrice || '--'
      lowestTotalPrice = lowestTotalPrice || '-'
      topTotalPrice = topTotalPrice || '-'
      const totalType = `${lowestTotalPrice}-${topTotalPrice}`
      const averageType = `${averagePrice}`
      if (displayPriceType === 2) {
        return totalPriceUnit && totalPriceUnit.indexOf('待定') !== -1 ? '价格待定' : totalType
      } else {
        return averagePriceUnit && averagePriceUnit.indexOf('待定') !== -1 ? '价格待定' : averageType
      }
    },
    projectPriceUnit() {
      let { averagePriceUnit, totalPriceUnit, displayPriceType } = this.info
      averagePriceUnit = averagePriceUnit || '均价（元/平）'
      totalPriceUnit = totalPriceUnit || '万元/套'
      if (displayPriceType === 2) {
        return totalPriceUnit && totalPriceUnit.indexOf('待定') !== -1 ? '' : totalPriceUnit
      } else {
        return averagePriceUnit && averagePriceUnit.indexOf('待定') !== -1 ? '' : averagePriceUnit
      }
    },
  },
  mounted() {
    this.getWxaCode3(this.projectCode)
  },
  methods: {
    mouseOver(){
      const projectCode = this.projectCode
      this.wxCodeShow = true
      clearTimeout(this.timer);
      this.timer = setTimeout(() => {
        if (this.wxCode) {
          return
        }
        this.getWxaCode(projectCode)
      }, 500);
    },
    // 生成小程序二维码
    getWxaCode(projectCode){
      const url = `pages/universalMarketing/recommend/index?projectCode=${projectCode}&fromPage=officialWebsite`
      this.$api.getWxaCode(url).then(res => {
        const wxCode = res.data
        this.wxCode = wxCode
      })
    },
    mouseOver2(){
      const projectCode = this.projectCode
      this.wxCodeShow2 = true
      clearTimeout(this.timer2);
      this.timer2 = setTimeout(() => {
        if (this.wxCode2) {
          return
        }
        this.getWxaCode2(projectCode)
      }, 500);
    },
    // 生成小程序二维码
    getWxaCode2(projectCode){
      const url = `pages/orderHouseInspection/index?homePageId=${this.homePage.id}&projectCode=${projectCode}&jumpType=project&fromPage=officialWebsite&configCode=PREVIEW-2112243574413563949`
      this.$api.getWxaCode(url).then(res => {
        const wxCode2 = res.data
        this.wxCode2 = wxCode2
      })
    },
    getWxaCode3(projectCode){
      const url = `pages/exhibitionHall/multiProject/detail?projectCode=${projectCode}&fromPage=officialWebsite`
      this.$api.getWxaCode(url).then(res => {
        const wxCode3 = res.data
        this.wxCode3 = wxCode3
      })
    },
  }
}
</script>
<style lang="scss" scoped>
.project-info {
  width: 428px;

  .title {
    display: flex;
    justify-content: space-between;
    align-items: center;

    .name {
      text-align: left;

      p:nth-child(1) {
        @include font28(600);
      }

      p:nth-child(2) {
        @include font16(400, #9399A5);
        margin-top: 20px;
        margin-bottom: 24px;
      }
    }

    .qrcode {
      transition: transform .5s ease .5s;

      &:hover {
        transform: scale(2);
      }

      img {
        width: 80px;
        height: 80px;
      }
    }
  }

  .price {
    text-align: left;

    span:nth-child(1) {
      @include font16(400, #9399A5);
      padding-right: 17px;
    }

    span:nth-child(2) {
      font-size: 52px;
      font-family: TCloudNumber-Bold, TCloudNumber;
      font-weight: bold;
      color: #FA5741;
      line-height: 52px;
    }

    span:nth-child(3) {
      @include font14(400, #FA5741);
    }
  }

  .info-tags {
    padding: 24px 0;
    overflow: hidden;
    border-top: 1px solid #E6E6E6;
    margin-top: 21px;

    .info-item {
      text-align: left;
      margin-bottom: 8px;

      span:nth-child(1) {
        @include font14(400, #9399A5);
      }

      span:nth-child(2) {
        @include font14(400, #333333);
        padding-left: 24px;
      }
    }

    .tags-wrap {
      text-align: left;
      margin-top: 20px;

      span {
        display: inline-block;
        padding: 5px 12px;
        background: #FFF0D3;
        @include font12(400, #BDA26C);
        margin-right: 12px;
      }
    }
  }

  .telephone {
    border-top: 1px solid #E6E6E6;

    .title {
      @include font16(400, #333333);
      margin-top: 24px;
    }

    .phone {
      @include font18(400, #FA5741);
      font-family: TCloudNumber-Regular, TCloudNumber;
      margin-top: 11px;

      .phone-number {
        padding-left: 4px;
      }
    }

    .wx-code {
      display: flex;
      margin-top: 15px;

      .right-item {
        height: 50px;
        border-radius: 2px;
        background-color: rgba(195, 161, 99, 1);
        width: 152px;
        cursor: pointer;
        text-align: center;
        padding-top: 13px;

        .right-item-thumbnail {
          margin-right: 8px;
          vertical-align: -2px;
        }

        &:hover {
          text-decoration: underline;
        }

        &.wx {
          position: relative;

          &:hover {
            text-decoration: underline;

            .wx-popu {
              display: block;
            }
          }

          // .wx-popu{
          //   display: none;
          //   position: absolute;
          //   top: 45px;
          //   left: 7px;
          //   width: 136px;
          //   height: 176px;
          //   .wx-img{
          //     width: 136px;
          //     height: 176px;
          //   }
          // }
          .wx-popu {
            position: absolute;
            top: 40px;
            left: -27px;
            width: 148px;
            height: 190px;
            z-index: 9;

            .wx-img {
              width: 198px;
              height: 268px;
              padding-top: 13.5px;
            }

            .wx-code {
              width: 150px;
              height: 150px;
              background-color: #fff;
              position: absolute;
              top: 34px;
              left: 24px;
            }
          }

          .wx-word {
            display: inline-block;
            color: rgba(255, 255, 255, 1);
            font-size: 16px
          }
        }
      }

      .right-item2 {
        border: 1px solid rgba(195, 161, 99, 1);
        background-color: rgb(255, 255, 255);
        margin-left: 10px;

        .wx-word {
          color: rgba(195, 161, 99, 1) !important;
        }
      }
    }
  }
}
</style>
